import "core-js/stable";
import dayjs from "dayjs";
import minMax from "dayjs/plugin/minMax";
import React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import App from "./App";
import { i18n } from "./config/locales/i18n";
import { CustomSnackbarProvider } from "./utils/custom-snackbar-provider";
import { telemetryService } from "./app-insights";

// https://day.js.org/docs/en/plugin/min-max
dayjs.extend(minMax);

telemetryService().initialize();

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

// React.StrictMode is intentionally NOT used here.
// MUI v4's makeStyles/useSynchronousEffect caches the style sheet key in a useRef.
// React 18 StrictMode reuses the same component instance across its
// simulate-unmount/remount cycle. This causes makeStyles to skip re-calling
// attach() on the remount (because the ref key still matches), so JSS never
// re-injects the styles after StrictMode's cleanup calls detach().
// The result is empty <style data-meta="MuiBox"> tags and missing spacing
// for all Box-based components in development mode.
// This is a known MUI v4 ↔ React 18 incompatibility; the fix is to
// upgrade to MUI v5 (which uses emotion instead of JSS) or remove StrictMode.
root.render(
  <I18nextProvider i18n={i18n}>
    <CustomSnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <App />
    </CustomSnackbarProvider>
  </I18nextProvider>,
);

